module.exports = __webpack_public_path__ + "img/vue1-arriere_lavande.95f93f10.png";